import React from 'react';
import { graphql } from 'gatsby';
import Container from '@atoms/Container';
import PageTitle from '@atoms/PageTitle';
// import Breadcrumbs from '@sections/Breadcrumbs';
import paddingDefault from '@utils/paddingDefault';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import Link from "../primitives/link";;
import { colors } from '../primitives/colors';

const FranchiseDisclosure = ({ data }) => {
    const { page_heading, lists } = data;

    return (
        <div css={paddingDefault()}>
            <Container>
                {/* <div css={styles.breadcrumbsWrap}>
          <Breadcrumbs />
        </div> */}
                <PageTitle css={styles.pageTitle}>
                    {apCaseOnlyTitleTags(page_heading)}
                </PageTitle>
                {lists.map(list => {
                    const { list_heading, links } = list
                    return (
                        <div css={styles.list} key={list_heading}>
                            <h2 css={styles.listHeading}>
                                {apCaseOnlyTitleTags(list_heading)}
                            </h2>
                            <ul css={styles.links}>
                                {links.map(({ title, href }) => {
                                    return (
                                        <Link css={styles.link} className="hover-default" to={href} key={title}>
                                            {title}
                                        </Link>
                                    )
                                })}
                            </ul>
                        </div>
                    )
                })}
            </Container>
        </div>
    );
};

const styles = {
    link: {
        textDecoration: "underline",
        color: colors.primaryOrange
    },
    breadcrumbsWrap: {
        "@media (min-width: 1024px)": {
            marginBottom: "0.75rem"
        }
    },
    pageTitle: {
        marginBottom: "0.75rem",
        maxWidth: "42rem",
        "@media (min-width: 1024px)": {
            marginBottom: "2rem"
        }
    },
    list: {
        paddingTop: "3.5rem",
        paddingBottom: "3.5rem",
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        fontWeight: 600
    },
    listHeading: {
        paddingBottom: "1rem",
        marginBottom: "1.5rem",
        borderBottomWidth: "1px",
        borderColor: colors.primaryOrange
    },
    links: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        ">:not([hidden])~:not([hidden])": {
            marginTop: "1.75rem"
        },
    }
};

export const query = graphql`
  fragment FranchiseDisclosureData on CmsPageBuilderBlocks {
    franchise_disclosure {
      page_heading
      lists {
        list_heading
        links {
          href
          title
        }
      }
    }
  }
`;

export default FranchiseDisclosure;
